<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <!-- อบรมนักธุรกิจอ่้อย -->
    <section id="farmer-dev-sys">
        <div class="col-md-12">
            <div class="card card-primary card-outline card-tabs">
                <p class="card-title pl-2 mt-2 headText2"><i class="fas fa-users"></i> ระบบรฝึกอบรมนักธุรกิจไร่อ้อย</p>
                <div class="card card-body">
                    <div class="card-header d-flex p-0">
                        <ul class="nav nav-pills mr-auto p-2">
                            <li (click)="id_now=0;setaddfm = false;" class="nav-item"><a class="nav-link active" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> บันทึกความรู้ความสามารถที่จำเป็น<span class="badge bg-warning"></span></a>
                            </li>
                            <li (click)="id_now=1;setaddfm = false;" class="nav-item"><a class="nav-link" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> บันทึกหลักสูตร<span class="badge bg-warning"></span></a>
                            </li>
                            <li (click)="id_now=2;setaddfm = false;" class="nav-item"><a class="nav-link"  data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> รายการฝึกอบรม <span class="badge bg-warning"></span></a>
                            </li>
                            <li (click)="id_now=3;setaddfm = false;" class="nav-item"><a class="nav-link" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> แสดงภาพรวมรายการฝึกอบรม<span class="badge bg-warning"></span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            
                <div *ngIf="id_now==0">
                    <div class="card-header bg-success">
                        <div class="card-title">บันทึกความรู้ความสามารถที่จำเป็นสำหรับชาวไร่</div>
                    </div>
                    <div class="card-body">
                        <div class="row ">
                            <div class="col"></div>
                            <div class="col-md-3">
                                <div *ngFor="let item of main_topic" >
                                    <button type="button" [ngClass]="{'btn btn-outline-success btn-block' : true }" name="type" 
                                        [value]="item.id" (click)="SubTypeSelectS(item.type,item.name)">เลือก:{{item.name}} 
                                    </button>
                                    <!-- <input *ngIf="item.ck_used.trim()==='1'" type="radio" name="selectqueue" formControlName="selectqueue" value="{{item.q_id}}"><label for="female">{{item.q_id}}</label> -->
                                </div>
                            </div>
                            <div class="col-md-4">
                                <table class="table table-bordered" style="width:100%" *ngIf="selectSub_topic.length>0"> 
                                    <thead>
                                        <tr>
                                            <th style="width:15%"></th>
                                            <th style="width:65%">{{selectMain.m_name}}</th>
                                            <th style="width:20%;text-align:center;">ยกเลิก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of selectSub_topic; let i = index;">
                                            <td style="text-align:center">{{i+1}}</td>
                                            <td>{{item.name}}</td>
                                            <td style="text-align:center;"><i class='fas fa-times' style='font-size:20px;color:red' (click)="cancel_topic(item.id)"></i></td>
                                        </tr>
                                    </tbody>                                        
                                </table>
                            </div>
                            <div class="col-md-3">
                                <form [formGroup]="FormCheckandTrain" *ngIf="selectMain.type!=''"> 
                                    <div class="mb-3">
                                        <label cLabel for="s_name">เพิ่มหัวข้อย่อย:{{selectMain.m_name}}</label>                                            
                                        <input type="text" class="form-control" aria-label="Default" id="s_name" formControlName="name" [(ngModel)]="selectMain.s_name">
                                    </div> 
                                    <button type="button" class="btn btn-primary" (click)="saveMain_topic();" *ngIf="selectMain.s_name !=''">บันทึก</button> 
                                </form>                                    
                            </div>
                            <div class="col"></div>
                        </div>
                    </div>
                </div>
                    
                <!-- บันทึกข้อมูลหลักสูตร -->                
                <div *ngIf="id_now==1">
                    <div class="card-header bg-primary">
                        <div class="card-title">บันทึกหลักสูตรการฝึกอบรมนักธุรกิจไร่อ้อย</div> <p>Selected range: {{title_main.value | json}}</p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col"></div>
                            <div class="col-md-7">
                                <form [formGroup]="title_main">
                                    <div class="form-group">
                                        <!--<label class="form-label">ชื่อหลักสูตรการอบรม</label>
                                        <input type="text" class="form-control" formControlName="title_docs" >--> 
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-label>ชื่อหลักสูตรการอบรม</mat-label>
                                            <input matInput formControlName="title_docs" placeholder="" value="">
                                        </mat-form-field>                               
                                    </div>
                                    <div class="form-group">
                                        <!--<label class="form-label">เนื้อหา/คำอธิบาย</label>
                                        <textarea class="form-control" formControlName="title_Des"></textarea>-->
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-label>เนื้อหา/คำอธิบาย</mat-label>
                                            <textarea matInput formControlName="title_Des" placeholder=""></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group">
                                        <!--<label class="form-label">ผู้บรรยาย</label>
                                        <input type="text" class="form-control" formControlName="lecturer" >-->
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-label>ผู้บรรยาย</mat-label>
                                            <input matInput formControlName="lecturer" placeholder="">
                                        </mat-form-field>
                                    </div>
                                    <div class="form-group">
                                        <mat-form-field appearance="fill">
                                            <mat-label>ช่วงวันที่การฝึกอบรม</mat-label>
                                            <mat-date-range-input [rangePicker]="picker" disabled>
                                                <input matStartDate formControlName="dt_start" placeholder="วันที่เริ่มต้น">
                                                <input matEndDate formControlName="dt_end" placeholder="วันที่สุดท้าย">
                                            </mat-date-range-input>
                                            
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                                        </mat-form-field>                                        
                                    </div>
                                    <div class="form-group">                          
                                        <fieldset>
                                            <label class="form-label">รูปแบบการฝึกอบรม</label><br/>                                                                                  
                                            <div>                                                                                          
                                                <input type="radio" formControlName="type_p" value="1"> อบรม
                                                <input type="radio" formControlName="type_p" value="2"> OJT
                                                <input type="radio" formControlName="type_p" value="3">ทั้ง 2 อย่าง
                                            </div>                                           
                                        </fieldset>
                                        <!--<form class="example-form">
                                            <mat-radio-group formControlName="type_p" aria-label="รูปแบบการฝึกอบรม">
                                                <mat-radio-button value="1">อบรม</mat-radio-button>
                                                <mat-radio-button value="2">OJT</mat-radio-button>
                                                <mat-radio-button value="3">ทั้ง 2 อย่าง</mat-radio-button>                                                
                                            </mat-radio-group>
                                        </form>-->
                                    </div>                                    
                                    
                                    <div class="form-group">
                                        <label class="form-label">ความรู้</label><br/>                                            
                                        <div *ngFor="let data of sub_topic; let i=index">
                                            <label>
                                            <input type="checkbox" formControlName="data_info" name="data_info" [value]="data.id" (change)="onCheckboxChange($event)"/>
                                                {{i+1}}-{{data.name}}
                                            </label>
                                        </div>
                                    </div>
                                </form>
                                <button type="button" class="btn btn-outline-primary" (click)="SavedataTrainGroup();">บันทึก</button> 
                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                                <button type="button" class="btn btn-outline-warning" (click)=" resetdataGroup();">รีเซ็ต</button> 
                            </div>
                            <div class="col"></div>
                        </div>
                    </div>
                </div>     

                <!-- บันทึกข้อมูลผลการอบรม -->
                <div *ngIf="id_now==2">
                    <div class="card-header bg-warning">
                        <div class="card-title">รายการฝึกอบรม</div>
                    </div>
                    <form [formGroup]="insert_datatitle">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="card-body">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">เลือกหลักสูตรการอบรม</span>
                                        </div>
                                        <select class="custom-select" id="inputGroupSelect04" formControlName="title_id" (change)="LoadSubTraindata(insert_datatitle.value.title_id)">
                                            <option selected [ngValue]="''">--- เลือกรายการ ---</option>
                                            <option *ngFor="let item of title" [ngValue]="item.title_id">
                                                {{item.title_docs}}
                                            </option>
                                        </select>

                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-primary" (click)="setaddfm = true;" *ngIf="insert_datatitle.value.title_id!=''">เพิ่มชาวไร่</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-left">
                                    <!--<label>{{ title_Desc[0] | json }}</label>-->
                                    <table class="table">
                                        <thead>
                                            <tr style="text-align:center">
                                                <th>ชื่อหัวข้อ</th>
                                                <th>คำอธิบาย</th>                                                
                                                <th>ผู้บรรยาย</th>
                                                <th>ช่วงวันที่</th>
                                                <th>ประเภท</th>
                                                <th>จำนวนชาวไร่</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of title_Desc" style="text-align:center">
                                                <td>{{item.title_docs}}</td>
                                                <td>{{item.title_Description}}</td>
                                                <td>{{item.lecturer}}</td>
                                                <td>{{item.dt_start | adtob}} - {{item.dt_end | adtob}}</td>                                                                                               
                                                <td>{{item.type_p}}</td>
                                                <td>{{SubTraindata.length | number}}</td>
                                            </tr>
                                        </tbody>
                                    </table>                                    
                                </div>

                                <div class="card-body table-responsive p-2" style="height: 650px">
                                    <table class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap" style="width:100%" >
                                        <thead>
                                            <tr>
                                                <th style="text-align:center"></th>
                                                <th>โควตา</th>
                                                <th>ชื่อชาวไร่</th>
                                                <th style="text-align:center">โซน</th>
                                                <th style="text-align:center">การอบรม</th>                                                
                                                <th>วันที่อัพเดต</th>
                                                <th>หมายเหตุ</th>
                                                <th ></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of SubTraindata; let i = index;">
                                                <td style="text-align:center">{{i+1 | number}}</td>
                                                <td>{{item.fmcode}}</td>
                                                <td>{{item.fmname}}</td>
                                                <td style="text-align:center">{{item.supzone}}</td>
                                                <td style="text-align:right">{{item.results_desc}}
                                                    <button mat-button [matMenuTriggerFor]="editresults" #menuTrigger>
                                                        <a class='far fa-edit' style='font-size:20;color:red'> </a>
                                                    </button>
                                                    <mat-menu #editresults="matMenu">
                                                        <button type="button" class="btn btn-outline-success" (click)="getdata(item.fmcode,item.fmname,0)" *ngIf="item.results!=0">เข้าอบรม</button>
                                                        <button type="button" class="btn btn-outline-primary" (click)="getdata(item.fmcode,item.fmname,1)" *ngIf="item.results!=1">ผ่านการอบรม</button>
                                                    </mat-menu>
                                                </td>
                                                <td>{{THtoLocalstring(item.date_update)}}</td>
                                                <td>{{item.comment}}</td>
                                                <td style="text-align:center;"><i class='fas fa-times' style='font-size:24px;color:red' (click)="CancleTrain(item.pr_id)"></i></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>                                
                            </div>
                            <div class="col-md-5">
                                <div class="card" *ngIf="setaddfm==true">
                                    <div class="card-body">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">ค้นหาชาวไร่</span>
                                            </div>
                                            <input type="text" class="form-control" placeholder="Search Here" formControlName="term">
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-outline-success" (click)="txtSearch=insert_datatitle.value.term;" >ค้นหา</button>
                                            </div>
                                        </div>
                                    </div>                                        
                                    <div class="card-body table-responsive p-2" style="height: 300px">
                                        <table class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap" style="width:100%" >
                                            <thead>
                                                <tr>
                                                    <th style="text-align:center;">No</th>
                                                    <th>โควตา</th>
                                                    <th>ชื่อชาวไร่</th>
                                                    <th style="text-align:center;">โซน</th>
                                                    <th style="text-align:center;">เข้าอบรม</th>
                                                    <th style="text-align:center;">ผ่านอบรม</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of AlldataFm | filter:txtSearch ; index as i">
                                                    <td style="text-align:center;">{{i+1 | number}}</td>
                                                    <td>{{item.FMCODE}}</td>
                                                    <td>{{item.fmname}}</td>
                                                    <td style="text-align:center;">{{item.SUPZONE}}</td>
                                                    <td style="text-align:center;"><i class='fas fa-chevron-circle-down' style='font-size:28;color:green' (click)="getdata(item.FMCODE,item.fmname,0)" ></i></td>
                                                    <td style="text-align:center;"><i class='fas fa-chevron-circle-down' style='font-size:28;color:blue' (click)="getdata(item.FMCODE,item.fmname,1)" ></i></td>
                                                </tr>
                                            </tbody>
                                        </table>  
                                    </div>
                                </div>
                                <div class="card" *ngIf="dataAr.length > 0">
                                    <div class="card-header">รายการข้อมูลที่เลือก </div>
                                    <div class="card-body">
                                        <div class="input-group mb-3 col-sm-12">
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)" formControlName="comment"> 
                                            </div>
                                            <div class="col-sm-3">
                                                <button mat-raised-button color="primary" (click)="SaveTrainS();">บันทึก {{dataAr.length}} รายการ</button>
                                            </div>
                                            <div class="col-sm-3">
                                                <button mat-raised-button color="warn" (click)="dataAr=[];">ยกเลิกการเลือก</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-2" style="height: 300px">
                                        <table class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap" style="width:100%" *ngIf="dataAr.length>0">
                                            <thead>
                                                <tr>
                                                    <th style="text-align:center ;">No</th>
                                                    <th>โควตา</th>
                                                    <th>ชื่อชาวไร่</th>
                                                    <th style="text-align:center;">ผลการอบรม</th>
                                                    <th style="text-align:center;">ยกเลิก</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of dataAr ; index as i">
                                                    <td style="text-align:center;">{{i+1 | number}}</td>
                                                    <td>{{item.FMCODE}}</td>
                                                    <td>{{item.fmname}}</td>
                                                    <td style="text-align:center;">
                                                        <label class="form-label" *ngIf="item.tid==0">เข้าอบรม</label>
                                                        <label class="form-label" *ngIf="item.tid==1">ผ่านการอบรม</label>
                                                    </td>
                                                    <td style="text-align:center;">
                                                        <i class='fas fa-times' style='font-size:22px;color:red' (click)="deletesomevalue(item.FMCODE);"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- ภาพรวมการฝึกอบรม  -->
                <div *ngIf="id_now==3">
                    <div class="card-header bg-info">
                        <div class="card-title">แสดงภาพรวมรายการฝึกอบรม</div>
                    </div>
                    <!--<mat-card class="example-card" [hidden]="showall" style="overflow-x: auto;">
                        <mat-form-field appearance="standard">
                        <mat-label>ค้นหา</mat-label>
                        <input matInput (keyup)="Filterby($event)" placeholder="โซน ชื่อ โควตา ผลการอมรม  " #input>
                        </mat-form-field>
                        
                        <table mat-table [dataSource]="TrainallList" matSort >
                        
                        <ng-container matColumnDef="date_training_th" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 150px;" id="KanitTH"> วันที่ฝึกอบรม </th>
                            <td mat-cell *matCellDef="let element"> {{element.date_training_th}} </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="fmcode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px;" id="KanitTH"> โควตา </th>
                            <td mat-cell *matCellDef="let element"> {{element.fmcode}} </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="fmname">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 200px;" id="KanitTH"> ชื่อ - สกุล </th>
                            <td mat-cell *matCellDef="let element"> {{element.fmname}}  </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="title_docs">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="KanitTH"> หลักสูตร / ผู้ฝึกอบรม </th>
                            <td mat-cell *matCellDef="let element"> {{element.title_docs}} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="supzone">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 150px;" id="KanitTH"> โซน </th>
                            <td mat-cell *matCellDef="let element"> {{element.supzone}} </td>
                            </ng-container>
    
                        <ng-container matColumnDef="results_desc" >
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px;" id="KanitTH"> ผลการอมรม </th>
                            <td mat-cell *matCellDef="let element"> {{element.results_desc}} </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="comment">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px;" id="KanitTH"> หมายเหตุ </th>
                            <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="date_add_th">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 200px;" id="KanitTH"> วันที่บันทึกข้อมูล </th>
                            <td mat-cell *matCellDef="let element"> {{element.date_add_th}}  </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="editdata">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 150px;" id="KanitTH"> แก้ไขข้อมูล </th>
                            <td  *matCellDef="let element" [formGroup]="FormCheckandTrain">  
                            
                                <select   class="form-select" formControlName="title_check" (change)="Editdatatrain(element.pr_id,element.results);"  id="check" >
                                <option   [ngValue]="0" [selected]>-- เลือกรายการ -- </option>
                                <option   [ngValue]="1">ผ่าน</option>
                                <option   [ngValue]="2">ไม่ผ่าน</option>
                                <option  [ngValue]="3">ระหว่างตรวจสอบ</option>   
                                </select>                         
                            
                        </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="cancelddata">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="KanitTH"> ยกเลิก </th>
                            <td mat-cell *matCellDef="let element"> <button mat-raised-button color="warn" (click)="CancleTrain(element.pr_id);">ยกเลิก</button></td>
                            </ng-container>                        
            
                        <tr mat-header-row color="primary" *matHeaderRowDef="trainallListColumns ; sticky: true;" ></tr>
                        <tr mat-row *matRowDef="let row; columns: trainallListColumns;"></tr>
                        
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                        </tr>
                        </table>                        
                    </mat-card>
                    -->
                </div>
            </div>                
        </div>        
    </section>
</div>

<app-footer></app-footer>